import { query } from 'atomic-layout';
import styled from 'styled-components';

import { MaxWidth } from '@/styles/shared/MaxWidth';

export const Container = styled(MaxWidth)`
  display: flex;
  padding: 112px 0;
  align-items: center;
  flex-direction: column;
  max-width: 1280px;

  @media ${query({ to: 'sm' })} {
    padding: 56px 0 56px 0;
  }
`;

export const Divider = styled.div`
  height: 96px;
  width: 100%;

  @media ${query({ to: 'sm' })} {
    height: 75px;
  }

  @media ${query({ to: 'xs' })} {
    height: 65px;
  }
`;

export const TextContainer = styled.div`
  max-width: 1280px;
  text-align: center;

  h2 {
    color: ${props => props.theme.colors.display[900]};
    font-weight: 700;
  }

  h3 {
    margin-top: 12px;
    font-weight: lighter;
    color: ${props => props.theme.colors.display[600]};
  }

  h4 {
    margin-top: 12px;
    font-weight: normal;
    color: ${props => props.theme.colors.display[900]};
  }

  @media ${query({ to: '1335' })} {
    padding: 0 24px;
  }

  @media ${query({ to: 'sm' })} {
    padding: 0 16px;
    margin-bottom: 20px;
  }
`;

export const TotalControlCard = styled.div``;

export const PlugPayCard = styled.div``;

export const TechnologyCard = styled.div``;

export const ExperienceCard = styled.div``;

export const LogoContainer = styled.div`
  margin-bottom: 48px;
  max-width: 60vw;
`;
